import React from 'react';

const BackButton = () => <div className='w-5 h-5 bg-tertiary rounded-sm animate-pulse' />;

const CompanyHeader = () => (
  <header className='pb-12 flex items-center flex-col gap-y-3'>
    <div className='overflow-hidden w-25 h-25'>
      <div className='animate-pulse bg-tertiary rounded-lg w-full h-full' />
    </div>
    <div className='flex flex-col gap-y-1 items-center'>
      <div className='w-48 h-6 bg-tertiary rounded-sm animate-pulse' />
      <div className='w-32 h-5 bg-tertiary rounded-sm animate-pulse' />
    </div>
  </header>
);

const InputFieldSkeleton = ({ label, htmlFor }: { label: string; htmlFor: string }) => (
  <div>
    <div className='flex flex-row items-center mb-2'>
      <label className='text-primary text-body-xs' htmlFor={htmlFor}>
        {label}
      </label>
    </div>
    <div className='flex flex-col'>
      <div className='relative flex items-center w-full'>
        <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
      </div>
    </div>
  </div>
);

const Divider = () => (
  <div className='tremor-Divider-root w-full mx-auto flex justify-between gap-3 items-center text-tremor-default text-tremor-content dark:text-dark-tremor-content my-10'>
    <div className='w-full h-px bg-tremor-border dark:bg-dark-tremor-border' />
  </div>
);

const FooterButtonsSkeleton = () => (
  <footer className='flex flex-wrap fixed bottom-0 left-0 right-0 gap-3 sm:gap-6 w-full bg-primary shadow-custom p-4 md:py-6 justify-center z-50'>
    <div className='w-[660px] flex gap-3 sm:gap-6 justify-end'>
      <div className='w-28 h-11 bg-tertiary rounded-md animate-pulse' />
      <div className='w-28 h-11 bg-tertiary rounded-md animate-pulse' />
    </div>
  </footer>
);

export const AddVenueSkeleton = () => {
  return (
    <>
      <div className='flex justify-center'>
        <div className='w-full md:w-[850px]'>
          <button className='rounded-full w-max mb-4 md:mb-6 px-4 md:px-0' type='button' aria-label='Menu'>
            <BackButton />
          </button>
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='flex justify-start w-[630px] flex-col mb-5 md:mb-40'>
          <CompanyHeader />

          <section>
            <h2 className='text-headline-m text-primary pb-6'>
              <div className='w-48 h-6 bg-tertiary rounded-sm animate-pulse' />
            </h2>
            <div className='grid items-start grid-cols-1 gap-4'>
              <InputFieldSkeleton label='Public Name' htmlFor='publicName' />
              <InputFieldSkeleton label='Address' htmlFor='address' />
              <InputFieldSkeleton label='City' htmlFor='city' />
              <InputFieldSkeleton label='Country' htmlFor='country' />
            </div>
          </section>

          <Divider />

          <section>
            <h2 className='text-headline-m text-primary pb-6'>
              <div className='w-32 h-6 bg-tertiary rounded-sm animate-pulse' />
            </h2>
            <div className='grid items-start grid-cols-1 gap-4'>
              <InputFieldSkeleton label='Instagram' htmlFor='instagram' />
              <InputFieldSkeleton label='Website' htmlFor='website' />
              <InputFieldSkeleton label='Google Maps URL' htmlFor='googleMapsUrl' />
            </div>
          </section>
        </div>
      </div>
      <FooterButtonsSkeleton />
    </>
  );
};
